import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const fetchLogisticIndices = (params = {}) => {
  return apiActionCreator({
    'endpoint': `/logistic-indices${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_INDICES,
      ActionTypes.FETCHED_LOGISTIC_INDICES,
      [
        ActionTypes.FETCHED_LOGISTIC_INDICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};


export const fetchLogisticnIndicesDetail = (params = {}) => {
  return apiActionCreator({
    'endpoint': `/logistic-indices/detail${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.FETCHING_LOGISTIC_INDICES_DETAIL,
      ActionTypes.FETCHED_LOGISTIC_INDICES_DETAIL,
      [
        ActionTypes.FETCHED_LOGISTIC_INDICES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};

export const downloadLogisticDetailExcel = (params = {}) => {
  return apiActionCreator({
    'endpoint': `/logistic-indices/detail/excel${getUrlParameters(params)}`,
    'authenticated': true,
    'types': [
      ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAILL_REQUEST,
      ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAIL_SUCCESS,
      [
        ActionTypes.DOWNLOAD_LOGISTIC_INDICES_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });
};


export const clearLogisticIndices = () => ({
  'type': ActionTypes.CLEAR_LOGISTIC_INDICES,
});

export const clearLogisticIndicesDetailExcel = () => ({
  'type': ActionTypes.CLEAR_LOGISTIC_INDICES_DETAIL_EXCEL_FILE,
});
